<template>
  <v-card v-if="debts != null && debts.length > 0">
    <v-toolbar flat light color="white" v-if="$vuetify.breakpoint.smAndDown">
      <v-toolbar-title v-if="!showUncloseableVerdict">{{ $t('v-text-1') }}</v-toolbar-title>
      <v-toolbar-title v-if="showUncloseableVerdict && !verdictLoading">{{ $t('v-text-1-mandatory') }}</v-toolbar-title>
      <v-toolbar-title v-if="showUncloseableVerdict && verdictLoading">{{ $t('v-text-mandatory-loading') }}</v-toolbar-title>
      <template v-if="!showUncloseableVerdict">
        <v-spacer></v-spacer>
        <v-btn light icon @click="$emit('close')">
          <v-icon>fa-times</v-icon>
        </v-btn>
      </template>
    </v-toolbar>
    <v-divider v-if="$vuetify.breakpoint.smAndDown"></v-divider>
    <v-container class="pb-0" v-if="$vuetify.breakpoint.mdAndUp && !showUncloseableVerdict">
      <v-row justify="end">
        <div class="pa-3">
          <v-btn color="color-grey" depressed right text small @click="$emit('close')">
            <v-icon class="mr-3">fa-times</v-icon>
            <span>{{ $t('close') }}</span>
          </v-btn>
        </div>
      </v-row>
    </v-container>
    <v-container fluid>
      <v-row justify="center" v-if="showUncloseableVerdict">
        <v-col v-for="lang in languages"
               :key="lang.locale"
               v-if="lang.locale !== locale"
               class="text-center">
          <a class="text-uppercase font-weight-bold" @click="changeLocale(lang.locale)">
            {{ lang.fullText }}
          </a>
        </v-col>
      </v-row>
      <v-row justify="center" v-if="$vuetify.breakpoint.mdAndUp">
        <v-col class="text-center">
          <h3 class="my-0 text-h3" v-if="!showUncloseableVerdict">{{ $t('v-text-1') }}</h3>
          <h3 class="my-0 text-h3" v-if="showUncloseableVerdict && !verdictLoading">{{ $t('v-text-1-mandatory') }}</h3>
          <h3 class="my-0 text-h3" v-if="showUncloseableVerdict && verdictLoading">{{ $t('v-text-mandatory-loading') }}</h3>
        </v-col>
      </v-row>
      <!--v-row justify="center" v-for="debt in debts" :key="debt.nr">
        <div class="px-3">
          <span class="ok-title mr-2">{{ $t('debt') }}</span>
          <br v-if="$vuetify.breakpoint.smAndDown" />
          <span class="ok-subtitle small" data-matomo-mask>{{ debt.orderNr }}</span>
        </div>
        <div class="px-3">
          <span class="ok-title mr-2">{{ $t('creditor') }}</span>
          <br v-if="$vuetify.breakpoint.smAndDown" />
          <span class="ok-subtitle small">{{ debt.creditor.name }}</span>
        </div>
      </!v-row-->
      <template v-if="verdictLoading">
        <v-row justify="center">
          <v-col class="pa-5 my-5 text-center">
            <v-progress-circular :size="100" color="primary" indeterminate />
          </v-col>
        </v-row>
      </template>
      <template v-else>
        <v-row justify="center">
          <v-col cols="12" md="8">
            <p v-if="!showUncloseableVerdict">{{ $t('v-text-2-1') }} {{ $t('v-text-2-2') }}</p>
            <p v-else-if="debts.length > 1">{{ $t('v-text-2-1') }} <b>{{ $t('v-text-2-mandatory-multi') }}</b> {{ $t('v-text-3') }}</p>
            <p v-else-if="debts.length === 1">{{ $t('v-text-2-1') }} <b>{{ $t('v-text-2-mandatory') }}</b> {{ $t('v-text-3') }}</p>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col cols="12" md="8">
            <p class="text-h8 mt-0 text-center">{{ $t('v-text-4') }} </p>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col cols="12" sm="6" md="4">
            <p class="ok-title">
              {{ $t('v-text-5') }}
            </p>
            <v-text-field v-model="email"
                          :label="$t('emailAddress')"
                          @blur="$v.email.$touch()"
                          @change="$v.email.$touch()"
                          :error-messages="emailError"
                          outlined />
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <p class="ok-title">
              {{ $t('v-text-6') }}
            </p>
            <v-text-field v-model="confirmEmail"
                          :label="$t('emailAddress')"
                          @blur="$v.confirmEmail.$touch()"
                          @change="$v.confirmEmail.$touch()"
                          :error-messages="confirmEmailError"
                          outlined />
          </v-col>
        </v-row>

        <v-row justify="center">
          <div class="pa-3">
            <v-btn tile color="primary" class="wide-button" :loading="loading" :disabled="!isValid" @click="signVerdict">
              <span>{{ $t('v-text-7') }}</span>
            </v-btn>
          </div>
          <div class="pa-3" v-if="!showUncloseableVerdict">
            <v-btn tile outlined color="color-grey" class="wide-button" @click="$emit('close')">
              <span>{{ $t('close') }}</span>
            </v-btn>
          </div>
        </v-row>
        <v-row justify="center">
          <v-col cols="10" md="7">
            <p class="text-center mt-3" v-if="!showUncloseableVerdict">{{ $t('v-text-8') }}</p>
            <p class="text-center mt-3" v-else>{{ $t('v-text-8-mandatory') }}</p>
          </v-col>
        </v-row>
        <v-row justify="center" v-if="showUncloseableVerdict">
          <div class="pa-3">
            <v-btn tile outlined color="color-orange" class="wide-button" @click="onLogout">
              <span>{{ $t('logout') }}</span>
            </v-btn>
          </div>
        </v-row>
      </template>
    </v-container>
  </v-card>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { required, email, sameAs } from 'vuelidate/lib/validators'

  export default {
    props: ['debts'],
    data: function () {
      return {
        email: '',
        confirmEmail: '',
        loading: false
      }
    },
    methods: {
      signVerdict() {

        var data = {
          Email: this.confirmEmail,
          Lang: this.$store.getters.longLocale,
          IsMandatory: this.showUncloseableVerdict
        }

        if (this.isValid) {
          this.loading = true

          this.$store.dispatch('signVerdict', data).then((response) => {
            this.loading = false
            if (response != null && response.status === 0) {
              this.$store.commit('setVerdictData', data)
              this.$matomo && this.$matomo.trackEvent("Action", "Download Court's Decision", "Decision Auth Start")
              window.location.href = response.responseObject
            } else {
              this.$store.commit('setMessage', { type: 'error', text: response.errorCode, translate: true })
              if (this.showUncloseableVerdict) {
                this.$store.commit('setShowVerdictDialogQueried', true)
                this.$emit('close')
              }
            }
          }).catch(() => {
            this.loading = false
            this.$store.commit('setMessage', { type: 'error', text: 'error.server.0', translate: true })
            if (this.showUncloseableVerdict) {
              this.$store.commit('setShowVerdictDialogQueried', true)
              this.$emit('close')
            }
          })
        }
      },
      onLogout () {
        this.$emit('close')
        this.$store.dispatch('logout')
        window.localStorage.clear()
        this.$router.push('/')
      },
      changeLocale (locale) {
        this.$store.commit('setLocale', locale)
        window.dispatchEvent(new Event('resize'))
      }
    },
    computed: {
      ...mapGetters({
        debtor: 'debtor',
        languages: 'languages',
        locale: 'locale',
        verdictLoading: 'verdictLoading'
      }),
      isValid () {
        if (!this.$v.email.$error && this.$v.email.$dirty && !this.$v.confirmEmail.$error && this.$v.confirmEmail.$dirty) {
          return true
        } else {
          return false
        }
      },
      emailError () {
        const errors = []
        if (!this.$v.email.$dirty) return errors
        !this.$v.email.required && errors.push(this.$t('validation.email.required'))
        !this.$v.email.email && errors.push(this.$t('validation.email.email'))
        return errors
      },
      confirmEmailError () {
        const errors = []
        if (!this.$v.confirmEmail.$dirty) return errors
        !this.$v.confirmEmail.required && errors.push(this.$t('validation.email.required'))
        !this.$v.confirmEmail.sameAs && errors.push(this.$t('validation.email.sameAs'))
        return errors
      },
      showUncloseableVerdict () {
        let verdictNotDownloadedDebts = this.debts.find((debt) => {
          return debt.isVerdictDownloaded === false
        })

        if (verdictNotDownloadedDebts !== undefined) {
          return true
        } else {
          return false
        }
      }
    },
    validations: {
      email: {
        required,
        email
      },
      confirmEmail: {
        required,
        sameAs: sameAs('email')
      }
    }
  }
</script>

<i18n>
  {
  "fi": {
  "v-text-1": "Lataa käräjäoikeuden ratkaisu",
  "v-text-1-mandatory": "Avaamaton käräjäoikeuden ratkaisu",
  "v-text-2-1": "Et ole vielä avannut käräjäoikeudesta saamaasi ratkaisua.",
  "v-text-2-2": "Mikäli haluat tarkastella ratkaisun yksityiskohtia, voimme toimittaa tiedot sinulle sähköpostitse.",
  "v-text-2-mandatory": "Ennen kuin voit jatkaa muuta asiointiasi Oma B2 Impact -palvelussamme, sinun tulee sähköisesti tunnistautua ja tutustua käräjäoikeuden ratkaisuun.",
  "v-text-2-mandatory-multi": "Ennen kuin voit jatkaa muuta asiointiasi Oma B2 Impact -palvelussamme, sinun tulee sähköisesti tunnistautua ja tutustua käräjäoikeuden ratkaisuihin.",
  "v-text-3": "Lisäksi lähetämme saman ratkaisun sinulle sähköpostitse.",
  "v-text-4": "Syötä sähköpostiosoite johon tiedot toimitetaan:",
  "v-text-5": "Sähköpostiosoite",
  "v-text-6": "Sähköpostiosoite uudelleen",
  "v-text-7": "Tunnistaudu",
  "v-text-8": "Tunnistautumisen ja sähköisen allekirjoituksen jälkeen lähetämme ratkaisun tiedot sähköpostiisi, ja sinut ohjataan takaisin Oma B2 Impact -palveluun.",
  "v-text-8-mandatory": "Sähköisen allekirjoituksen jälkeen lähetämme ratkaisun sähköpostiisi, ja sinut ohjataan takaisin Oma B2 Impact -palveluun. Voit sen jälkeen tehdä suorituksia ja tarkastella velkasi tietoja entiseen tapaan.",
  "v-text-mandatory-loading": "Tallennamme tietoja, pieni hetki"
  },
  "se": {
  "v-text-1": "Ladda ner tingsrättens beslut",
  "v-text-1-mandatory": "Oöppnat beslut från tingsrätten",
  "v-text-2-1": "Du har ännu inte öppnat beslutet från tingsrätten.",
  "v-text-2-2": "Om du vill kontrollera beslutet kan vi skicka uppgifterna till dig per e-post.",
  "v-text-2-mandatory": "Innan du kan fortsätta med andra ärenden i vår tjänst Min B2 Impact, måste du identifiera dig elektroniskt och ta del av tingsrättens beslut.",
  "v-text-2-mandatory-multi": "Innan du kan fortsätta med andra ärenden i vår tjänst Min B2 Impact, måste du identifiera dig elektroniskt och ta del av tingsrättens alla beslut.",
  "v-text-3": "Vi skickar även samma beslut till dig via e-post.",
  "v-text-4": "Ange den e-postadress dit du vill att vi skickar uppgifterna:",
  "v-text-5": "E-postadress",
  "v-text-6": "Bekräfta din e-postadress",
  "v-text-7": "Identifiera dig",
  "v-text-8": "Efter att identifieringen och den elektroniska underskriften har blivit gjorda, skickar vi de begärda uppgifterna till din e-post och du flyttas därefter tillbaka till Min B2 Impact -tjänsten.",
  "v-text-8-mandatory": "Efter att den elektroniska underskriften har blivit gjord, skickar vi det begärda beslutet till din e-post och du flyttas därefter tillbaka till Min B2 Impact -tjänsten. Efter det du kan göra betalningar och kontrollera skuldens information som vanligt.",
  "v-text-mandatory-loading": "Vi sparar data, ett ögonblick"
  },
  "en": {
  "v-text-1": "Download court's decision",
  "v-text-1-mandatory": "Unopened district court decision",
  "v-text-2-1": "You have not yet opened the decision you received from the district court.",
  "v-text-2-2": "If you wish to get a copy of the verdict, we can deliver it to you by email.",
  "v-text-2-mandatory": "Before proceeding with any other matters in our My B2 Impact service, you must authenticate yourself electronically and review the district court decision.",
  "v-text-2-mandatory-multi": "Before proceeding with any other matters in our My B2 Impact service, you must authenticate yourself electronically and review the district court decisions.",
  "v-text-3": "We will also send the same decision to you via email.",
  "v-text-4": "Please provide Your email address:",
  "v-text-5": "Email",
  "v-text-6": "Verify email",
  "v-text-7": "Proceed to authentication",
  "v-text-8": "After authentication and electronic signing is completed, we'll send the document to your email, and you will be directed back to My B2 Impact -service.",
  "v-text-8-mandatory": "After authentication you can sign the request, and we will send a copy of the verdict to the email address you provided. After that you can view your case’s details and make payments etc. normally.",
  "v-text-mandatory-loading": "We are saving the information, just a moment"
  }
  }
</i18n>
